import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from './language-context';
import { useSession } from './session-context';
import { canAccess, navItemFor } from './nav-items';
import type { SectionId } from './nav-items';
import { formatMessage } from '@bookingdei/i18n/interpolate';

// Section guard used by router.tsx (pure wiring there, the decision here). A
// section outside the viewer's role renders the design's restricted state
// (D:505-512) inside the shell instead of the screen — the screen's own calls
// would be refused server-side anyway (FR-A15; enforcement is the API's). Overview
// is open to every role.

export function RestrictedState({ section }: { section: SectionId }) {
  const { t, lang } = useLanguage();
  return (
    <div className="restricted" role="status">
      <div className="restricted__icon" aria-hidden="true">
        ⚿
      </div>
      <h1 className="restricted__title">{t('admin.shell.restricted.title')}</h1>
      <p className="restricted__body">
        {formatMessage(lang, 'admin.shell.restricted.body', { section: t(navItemFor(section).key) })}
      </p>
      <Link className="btn btn--ghost" to="/">
        {t('admin.shell.restricted.back')}
      </Link>
    </div>
  );
}

export function SectionRoute({ section, children }: { section: SectionId; children: ReactNode }) {
  const { grants } = useSession();
  if (section !== 'overview' && !canAccess(grants, section)) return <RestrictedState section={section} />;
  return <>{children}</>;
}
